import type { GetServerSidePropsContext, InferGetServerSidePropsType, NextPage } from "next";
import Head from "next/head";
import { b } from "@/b";
import { HEADER_FRAGMENT } from "@/components/Header";
import { PageLayout } from "@/components/PageLayout";
import { ChefSpecials_Fragment } from "@/components/pages/home/ChefSpecials";
import { MealTagShowcase_Fragment } from "@/components/pages/home/MealTagShowcase";
import { CategoryReel } from "@/components/pages/home-new/CategoryReel";
import { CtaSection } from "@/components/pages/home-new/CtaSection";
import { FeaturedMeals } from "@/components/pages/home-new/FeaturedMeals";
import { HeroProducts_Fragment, HeroSection } from "@/components/pages/home-new/HeroSection";
import { HowItWorks } from "@/components/pages/home-new/HowItWorks";
import { StorySection } from "@/components/pages/home-new/StorySection";
import { getApolloSSRProps, useHydratedQuery } from "@/util/apollo-client";

const HOME_QUERY = b.query("Home", (b) => [
  b.__fragment(HEADER_FRAGMENT),
  b.__fragment(MealTagShowcase_Fragment),
  b.__fragment(ChefSpecials_Fragment),
  b.__fragment(HeroProducts_Fragment),
]);

const HomeNew: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (props) => {
  const { data } = useHydratedQuery(props);

  return (
    <>
      <Head>
        <title>Visionary Meals</title>
        <meta
          name="description"
          content="Explore our delicious gluten-free, farm to table, fully-prepped meals!"
        />
      </Head>
      <PageLayout data={data} noPadding overlayHeader>
        <HeroSection data={data} />
        <CategoryReel data={data} />
        <HowItWorks />
        <FeaturedMeals data={data} />
        <StorySection />
        <CtaSection />
      </PageLayout>
    </>
  );
};

export default HomeNew;

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  return {
    props: await getApolloSSRProps(HOME_QUERY.document(), {}, ctx),
  };
};
